module.exports = __webpack_public_path__ + "img/cases-brand-suning-4.1e7f66d2.jpg";